import { useNavigator } from '@repo/toolkit/use-navigator'
import { SettingIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createMedicalTerm } from '../../../api/medical-terms/create-medical-term'
import UserNavBar from '../../../components/elements/nav-bar'
import MedicalTermForm from '../../../components/pages/medical-term/medical-term-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const MedicalTermCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createMedicalTerm,
    onError: showAxiosError,
    onSuccess: () => toast.success('Terme médical créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer Termes médicaux'} icon={SettingIcon} />
      <div className={'h-4'} />
      <MedicalTermForm
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            const res = await mutateAsync(values)
            navigate(Paths.MEDICAL_TERM_UPDATE_PAGE.replace(':id', res.id.toString()), {
              replace: true
            })
          },
          onCancel: () => back(Paths.MEDICAL_TERM_LIST_PAGE)
        })}
      />
    </div>
  )
}

export default MedicalTermCreatePage
